import api from './api'
export default {
    post: function(parms) {
      return api.post('grievance/post',parms)
    },
    get: function(parms) {
      return api.get('grievance/get',{
        params: parms
        })
    },
    
  }